import createHistory from 'history/createBrowserHistory';
import { isMqDesktop, isMqMobile } from 'mk/common/responsive';
import rootSagas from 'mk2/apps/blogs/sagas';
import {
    getLastKnownUsernameCookie,
    getPregnancyNewsletterClosedCookie,
    getPregnancyNewsletterCookie,
} from 'mk2/apps/users/utils';
import { getLogger } from 'mk2/logger';
import { AppState } from 'mk2/reducers';
import { initJam } from 'mk2/services/jam';
import { initStore } from 'mk2/store';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { Store } from 'redux';

declare const MK: any;
declare const ASMIRA: any;

let store;
let history;

let alerted = false;

const logger = getLogger('initialize');

/**
 * NOTE: This is TEMPORARY solution for pages which are not react/redux only (e.g. photoblogs)
 * to render redux components - Album, Comments
 */
export function initialize(element: HTMLElement, Component: React.ComponentType<{ store: Store<AppState> }>, hydrate = false): Store<AppState> {

    if (process.env.NODE_ENV === 'development' && !alerted) {
        logger.warn(
            `Using TEMPORARY solution to initialize React/Redux on page which is rendered by Django. Please rewrite whole page to by React only. If you see this warning in %c2020%c something is wrong or I'm dead.`,
            'font-weight: bold', 'font-weight: normal',
        );
        alerted = true;
    }

    if (!history) {
        // Read basename from <base href="" />
        const base = document.querySelector('base');
        const baseHref = base ? base.getAttribute('href') : '/';

        history = createHistory({
            basename: baseHref.replace(/\/$/, ''),
        });
    }

    if (!store) {
        const initialState: Partial<AppState> = typeof window !== 'undefined' ? (window as any).INITIAL_STATE : {};

        const mobile = isMqMobile();
        const desktop = isMqDesktop();

        // Detect mobile / desktop
        initialState.request = {
            baseUrl: '',
            user: MK.requestUser,
            permissions: MK.requestUserPermissions,
            userAgent: navigator.userAgent,
            device: {
                ...(initialState.request && initialState.request.device),
                mobile,
                desktop,
                // Save initial screen size to state
                screen: {
                    width: window.screen.availWidth,
                    height: window.screen.availHeight,
                },
                // Save initial viewport size to state
                viewport: {
                    width: document.documentElement.clientWidth || window.innerWidth,
                    height: document.documentElement.clientHeight || window.innerHeight,
                },
                keyboard: {
                    opened: false,
                    height: 200,
                },
            },
            phoneVerificationMode: MK.phoneVerificationMode,
            lastKnownUsername: getLastKnownUsernameCookie(),
            privacyLeaflet: initialState.request.privacyLeaflet,
            pregnancyNewsletterSubscribed: getPregnancyNewsletterCookie(),
            pregnancyNewsletterClosed: getPregnancyNewsletterClosedCookie(),
        };

        // Set cookie, so that we can use it during server side rendering
        document.cookie = `ssr_device=${mobile ? '1' : '0'}${desktop ? '1' : '0'}; path=/`;

        store = initStore(history, rootSagas, initialState);

        initJam(store.dispatch);
    }

    ReactDOM[hydrate ? 'hydrate' : 'render'](
        <Provider store={store}>
            {/* provider needs the unbound version of i18next (see exports in i18next/ws/index.js) */}
            <ConnectedRouter history={history}>
                <Component store={store} />
            </ConnectedRouter>
        </Provider>,
        element,
    );

    return store;
}
